import request from '@utils/request'

export function fetchPrivateMarkets() {
  return request({
    url: '/admin/market/private',
    method: 'get',
  })
}

export function fetchPrivateMarket(market_seq) {
  return request.get(`/admin/market/private/${market_seq || 0}`)
}

export function createPrivateMarket(data) {
  return request.post('/admin/market/private', data)
}

export function updatePrivateMarket({ market_seq, ...data }) {
  return request.put(`/admin/market/private/${market_seq || 0}`, data)
}

export function deletePrivateMarket(market_seq) {
  return request.delete(`/admin/market/private/${market_seq || 0}`)
}

export function fetchDirectMarkets() {
  return request({
    url: '/admin/market/direct',
    method: 'get',
  })
}

export function fetchDirectMarket(market_seq) {
  return request.get(`/admin/market/direct/${market_seq || 0}`)
}

export function createDirectMarket(data) {
  return request.post('/admin/market/direct', data)
}

export function updateDirectMarket({ market_seq, ...data }) {
  return request.put(`/admin/market/direct/${market_seq || 0}`, data)
}

export function deleteDirectMarket(market_seq) {
  return request.delete(`/admin/market/direct/${market_seq || 0}`)
}

export function fetchDirectTransferList(params) {
  return request({
    url: '/admin/market/direct/transfer',
    method: 'get',
    params,
  })
}

export function fetchPrivateDealList(params) {
  return request({
    url: '/admin/market/private/deal',
    method: 'get',
    params,
  })
}

export function fetchPrivateApplicationList(params) {
  return request({
    url: '/admin/market/private/application',
    method: 'get',
    params,
  })
}

export function setPrivateApplicationStatus(seq, status) {
  return request({
    url: `/admin/market/private/application/${seq}`,
    method: 'patch',
    data: {
      type: `SET_${status.toUpperCase()}`,
    },
  })
}

export function fetchPublicMarkets() {
  return request({
    url: '/admin/market/public',
    method: 'get',
  })
}

export function fetchPublicMarket(market_seq) {
  return request.get(`/admin/market/public/${market_seq || 0}`)
}

export function createPublicMarket(data) {
  return request.post('/admin/market/public', data)
}

export function updatePublicMarket({ market_seq, ...data }) {
  return request.put(`/admin/market/public/${market_seq || 0}`, data)
}

export function deletePublicMarket(market_seq) {
  return request.delete(`/admin/market/public/${market_seq || 0}`)
}

export function fetchPublicOrderList(params) {
  return request({
    url: '/admin/market/public/order',
    method: 'get',
    params,
  })
}

export function fetchPublicTradeList(params) {
  return request({
    url: '/admin/market/public/trade',
    method: 'get',
    params,
  })
}

export function fetchPublicBalanceTransferList(params) {
  return request({
    url: '/admin/market/public/balance-transfer',
    method: 'get',
    params,
  })
}
